import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-68cf383c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BurgerMenu = _resolveComponent("BurgerMenu")!
  const _directive_motion_fade = _resolveDirective("motion-fade")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ 'burger-menu-open': _ctx.isBurgerMenuOpen })
  }, [
    _withDirectives((_openBlock(), _createBlock(_component_router_link, {
      class: "logo",
      to: "/",
      delay: 300,
      onClick: _withModifiers(_ctx.scrollToTop, ["stop"])
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"])), [
      [_directive_motion_fade]
    ]),
    _withDirectives(_createVNode(_component_Button, {
      delay: 400,
      "icon-button": "",
      icon: require('@/assets/images/burger-menu.svg'),
      class: "burger-menu-button",
      onClick: _ctx.openBurgerMenu
    }, null, 8, ["icon", "onClick"]), [
      [_directive_motion_fade]
    ]),
    _createVNode(_component_BurgerMenu, {
      open: _ctx.isBurgerMenuOpen,
      onClose: _ctx.closeBurgerMenu
    }, null, 8, ["open", "onClose"])
  ], 2))
}